<template>
    <div ref="calendar"></div>
</template>

<script>    
    
    import { Calendar } from '@fullcalendar/core'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import listPlugin from '@fullcalendar/list'
    //import interactionPlugin from '@fullcalendar/interaction'
    import timelinePlugin from '@fullcalendar/timeline'

    import defaultsDeep from 'lodash.defaultsdeep'

    export default {

        props: {
            config: {
                type: Object,
                default() {
                    return {}
                },
            },
        },

        data(){ return {
            
            calendar: undefined,

            defaultConfig: {
                locale: 'da',
                firstDay: 1,
                aspectRatio: 2,
                timeFormat: 'H(:mm)',
                timeZone: 'UTC',
                //eventColor: '#ACFCD9',
                //eventTextColor: '#000',
                
                header: {
					left: 'prev,next today',
					center: 'title',
					right: 'dayGridMonth,timeGridWeek,timeGridDay, listMonth,listWeek,listDay, timelineCustom',
				},
				views: {
					
					dayGridMonth: { buttonText: 'Grid: Month' },
					timeGridWeek: { buttonText: 'Week' },
					timeGridDay: { buttonText: 'Day' },
					
					listMonth: { buttonText: 'List: Month' },
					listWeek: { buttonText: 'Week' },
					listDay: { buttonText: 'Day' },					

					timelineCustom: { 
						//defaultView: 'timeline',
  						type: 'timeline',
						duration: { days: 90, },
						buttonText: 'Timeline',
                        dateFormat: 'H(:mm)',
                        slotLabelFormat: [
                            { month: 'short', year: 'numeric' },
                            { day: 'numeric' },
                            { week: 'short' },                            
                            { weekday: 'narrow' },
                        ],
                        
					},
					
                },
                
                plugins: [ 
					dayGridPlugin, timeGridPlugin, listPlugin,
					//interactionPlugin, 
					timelinePlugin,
                ],
                eventRender: function (data) {
                    //console.log(event.event.extendedProps.booking.type)
                    if( data.event.extendedProps && data.event.extendedProps.booking && data.event.extendedProps.booking.type ) {
                        var type = data.event.extendedProps.booking.type.colorcode
                        data.el.classList.add('booking-type-'+type)
                    }

                },
            },

        } },

        computed: {

        },

        methods: {                        

        },

        watch: {
            
            
        },

        mounted() {

            var el = this.$refs.calendar            
            var config = defaultsDeep(this.config, this.defaultConfig)
            this.calendar = new Calendar(el, config)
		    this.calendar.render()                
            
        },

        beforeDestroy() {
            
            this.calendar.destroy()
            
        },
    }
</script>


// WEBPACK FOOTER //
// FullCalendar.vue?051a0cf8